export default __webpack_public_path__ + "static/media/6N.82ae0a0b.jpg";